// extracted by mini-css-extract-plugin
module.exports = {"container":"VYeGO8eoPZWxTThTnj65-","header":"_1EJJ3-OXY2RC_NH5zI0-DJ","text":"_3H2EidkZkoaTTnZdUNpXWJ"};